var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgAnnualLeave = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2598_53439)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9435 12.1335L12.1352 10.9419L16.9102 15.7169C17.2352 16.0419 17.2352 16.5752 16.9102 16.9085C16.5852 17.2335 16.0519 17.2335 15.7185 16.9085L10.9435 12.1335ZM14.5185 7.35854L15.5769 6.3002C16.3185 5.55854 16.2185 4.2752 15.3185 3.73354C12.0769 1.7502 7.79354 2.15854 4.98521 4.95854C8.26021 3.8752 11.9102 4.7502 14.5185 7.35854ZM4.96021 4.98354C2.16021 7.79187 1.75188 12.0752 3.72688 15.3169C4.27688 16.2169 5.55188 16.3252 6.29354 15.5752L7.35188 14.5169C4.75188 11.9085 3.87688 8.25854 4.96021 4.98354ZM4.97688 4.96687L4.96854 4.9752C4.65188 7.48354 5.94354 10.7085 8.55188 13.3252L13.3269 8.5502C10.7185 5.94187 7.48521 4.6502 4.97688 4.96687Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2598_53439"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAnnualLeave, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/annualLeave.a677b6a4.svg";
export { ForwardRef as ReactComponent };